import React, { useState, useEffect } from 'react';
import axios from "axios";
import classes from "./legalInfo.module.css";
import InputField from "../../../containers/inputField/inputField";
import DoubleArrow from "../../../../assets/images/red-arrow.png";
import WhiteArrow from "../../../../assets/images/double-arrow.png";
import { sixYardAxios } from '../../../../sixYardAxios';
import PromptMessage from '../../../containers/promptMessage/promptMessage';

const LegalInfo = (props) => {
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [isTermsChecked, setIsTermsChecked] = useState(false);
    const [allergies, setAllergies] = useState(false);
    const [allergiesDetails, setAllergiesDetails] = useState("");
    const [conditions, setConditions] = useState(false);
    const [conditionsDetails, setConditionsDetails] = useState("");
    const [medications, setMedications] = useState(false);
    const [medicationsDetails, setMedicationsDetails] = useState("");
    const [specialDiet, setSpecialDiet] = useState(false);
    const [specialDietDetails, setSpecialDietDetails] = useState("");
    const [countries, setCountries] = useState([]);
    const [childDetails, setChildDetails] = useState({
        kidsFullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: true
            },
            label: "Kid's Full Name",
            valid: false,
            touched: false
        },
        dateOfBirth: {
            withIcon: true,
            elementType: "input",
            elementConfig: {
                type: "calendarDate",
                placeholder: "Select date",
            },
            value: "",
            validation: {
                required: true,
            },
            label: "Date Of Birth",
            valid: false,
            touched: false
        },
        nationality: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: "Select nationality",
                options: []
            },
            value: "",
            validation: {
                required: true
            },
            label: "Nationality",
            valid: false,
            touched: false
        },
        gender: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: "Select gender",
                options: [
                    { value: "", displayValue: "Select gender", disabled: true },
                    { value: "male", displayValue: "Male" },
                    { value: "female", displayValue: "Female" }
                ]    
            },
            value: "",
            validation: {
                required: true
            },
            label: "Gender",
            valid: false,
            touched: false
        },
        schoolName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: true
            },
            label: "School Name",
            valid: false,
            touched: false
        }
    });
    const [healthAndMedical, setHealthAndMedical] = useState({
        hospitalPreference: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: false
            },
            label: "Hospital Preference",
            valid: false,
            touched: false
        },
        doctorsName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: false
            },
            label: "Doctor's Name",
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: false,
                isNumeric: true
            },
            label: "Doctor's Phone Number",
            valid: false,
            touched: false
        }
    });
    const [legalGuardianDetails, setLegalGuardianDetails] = useState({
        guardiansFullName: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: true
            },
            label: "Guardian's Full Name",
            valid: false,
            touched: false
        },
        relationToRegistrant: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: "Select relation type",
                options: [ { value: "", displayValue: "Select relation type", disabled: true },{ value: 'father', displayValue: 'Father' }, { value: 'mother', displayValue: 'Mother' }]
            },
            value: "",
            validation: {
                required: true
            },
            label: "Relation To Registrant",
            valid: false,
            touched: false
        },
        email: {
            elementType: "input",
            elementConfig: {
                type: "email",
                placeholder: "Enter email",
            },
            value: "",
            label: "Email",
            validation: {
                required: true,
                isEmail: true
            },
            valid: false,
            touched: false
        },
        phone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: "Phone Number",
            valid: false,
            touched: false
        },
        emergencyPhone: {
            elementType: "input",
            elementConfig: {
                type: "phone",
                placeholder: "07xxxxxxxx",
                options: []
            },
            value: "",
            valueName: "phone_number",
            validation: {
                required: true,
                isNumeric: true
            },
            label: "Emergency Phone Number",
            valid: false,
            touched: false
        }
    });
    const [addressDetails, setAddressDetails] = useState({
        city: {
            elementType: "select",
            elementConfig: {
                type: "select",
                placeholder: "Select city",
                options: []
            },
            value: "",
            validation: {
                required: true
            },
            label: "City",
            valid: false,
            touched: false
        },
        neighborhood: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: true
            },
            label: "Neighborhood",
            valid: false,
            touched: false
        },
        street: {
            elementType: "input",
            elementConfig: {
                type: "text",
                placeholder: "Enter name",
            },
            value: "",
            validation: {
                required: true
            },
            label: "Street",
            valid: false,
            touched: false
        },
        buildingNumber: {
            elementType: "input",
            elementConfig: {
                type: "number",
                placeholder: "Enter number",
            },
            value: "",
            validation: {
                required: true,
                isNumeric: true
            },
            label: "Building Number",
            valid: false,
            touched: false
        },
        apartmentNumber: {
            elementType: "input",
            elementConfig: {
                type: "number",
                placeholder: "Enter number",
            },
            value: "",
            validation: {
                required: true,
                isNumeric: true
            },
            label: "Apartment Number",
            valid: false,
            touched: false
        },
        postalCode: {
            elementType: "input",
            elementConfig: {
                type: "number",
                placeholder: "Enter number",
            },
            value: "",
            validation: {
                required: false,
                isNumeric: true
            },
            label: "Postal Code",
            valid: false,
            touched: false
        }
    });
    useEffect(() => {
        fetchCountries();
        fetchCities("Jordan")
    }, []);
    const fetchCountries = async () => {
        try {
            const response = await axios.get("https://countriesnow.space/api/v0.1/countries");
            
            const countryOptions = [
            { value: "", displayValue: "Select nationality", disabled: true }, // Add placeholder first
            ...response.data.data
             .map(country => ({
                    value: country.country === "Israel" ? "Palestine" : country.country,
                    displayValue: country.country === "Israel" ? "Palestine" : country.country,
                }))
                .filter((country, index, self) => 
                    index === self.findIndex((c) => (
                        c.value === country.value
                    ))
                )
                .sort((a, b) => a.displayValue.localeCompare(b.displayValue)) // Sort alphabetically
        ];
            updateControlOptions("nationality", countryOptions, setChildDetails);
            setCountries(response.data.data); // Note: This still holds the original data
        } catch (error) {
            console.error("Failed to fetch countries:", error);
        }
    };
    const updateControlOptions = (controlName, options, updateState) => {
        updateState((prevControls) => ({
            ...prevControls,
            [controlName]: {
                ...prevControls[controlName],
                elementConfig: {
                    ...prevControls[controlName].elementConfig,
                    options: options,
                },
            },
        }));
    };
    const form = (controlFunction, state) => {
        const formElementsArray = [];
        for (let key in state) {
            formElementsArray.push({
                id: key,
                config: state[key]
            });
        }
        return (
            formElementsArray.map((formElement, i) => (
                <div key={i} className={classes.FormGroup}>
                    <InputField
                        key={formElement.id}
                        elementType={formElement.config.elementType}
                        elementConfig={formElement.config.elementConfig}
                        value={formElement.config.value}
                        invalid={!formElement.config.valid}
                        shouldValidate={formElement.config.validation}
                        touched={formElement.config.touched}
                        withRemove={false}
                        withIcon={formElement.config.withIcon}
                        label={formElement.config.label}
                        changed={event => inputChangedHandler(event, formElement.id, controlFunction, state)}
                    />
                </div>))
        )
    }
    const fetchCities = async (country) => {
        try {
            const jordanCities = [
                'Amman',
                'Naour',
                'Wadi as-Sir',
                'Umm as-Summāq',
                'Zarqa',
                'Russeifa',
                'Al-Hashimiyah',
                'Ad-Dhlail',
                'Irbid',
                'Aydoun',
                'Beit Ras',
                'Al Husn',
                'As-Sarih',
                'Mafraq',
                'Al Mukhayzin',
                'Ajloun',
                'Kufranjah',
                'Karak',
                'Al Jafr',
                'Al Quwayrah',
                'Ma\'an',
                'Petra',
                'Aqaba',
                'Tafila',
                'Madaba',
                'Umm al-Rasas',
                'Jerash',
                'Salt'
            ];
            const cityOptions = [
            { value: "", displayValue: "Select city", disabled: true }, // Add placeholder first
            ...jordanCities
                .map(city => ({
                    value: city,
                    displayValue: city,
                }))
                .sort((a, b) => a.displayValue.localeCompare(b.displayValue)) // Sort alphabetically
        ];
            updateControlOptions("city", cityOptions, setAddressDetails);
        } catch (error) {
            console.error("Failed to fetch cities:", error);
        }
    };
    const checkValidity = ((value, rules) => {
        let isValid = true;
        if (!rules) {
            return true;
        }

        if (rules.required) {
            value = typeof value === 'string' ? value.trim() : value;
            isValid = value !== "" && isValid;
        }

        if (rules.isEmail) {
            const pattern = /[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/;
            isValid = pattern.test(value) && isValid;
        }

        if (rules.isNumeric) {
            const pattern = /^\d+$/;
            isValid = pattern.test(value) && isValid;
        }

        return isValid;
    })

    const inputChangedHandler = (event, controlName, controlFunction, state) => {
        const value = (controlName === 'phone' || controlName === 'emergencyPhone' || controlName === 'dateOfBirth') ? event : event.target.value;
        const updatedControls = {
            ...state,
            [controlName]: {
                ...state[controlName],
                value,
                valid: checkValidity(value, state[controlName].validation),
                touched: true
            }
        };

        // Directly update the specific field instead of the entire form state
        controlFunction(updatedControls);
    };

    const backHandler = () => {
        props.setCurrentStep(props.currentStep - 1)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.registrationId,
                "kid's": {
                    name: childDetails.kidsFullName.value,
                    date_of_birth: childDetails.dateOfBirth.value,
                    nationality: childDetails.nationality.value,
                    gender: childDetails.gender.value,
                    school_name: childDetails.schoolName.value
                },
                medical_info: {
                    allergies: allergiesDetails,
                    conditions: conditionsDetails,
                    medications: medicationsDetails,
                    special_diet: specialDietDetails
                },
                hospital_preference: healthAndMedical.hospitalPreference.value,
                doctor_name: healthAndMedical.doctorsName.value,
                doctor_phone: healthAndMedical.phone.value?.dialCode + healthAndMedical.phone?.value?.number,
                guardian: {
                    full_name: legalGuardianDetails.guardiansFullName.value,
                    relation_type: legalGuardianDetails.relationToRegistrant.value,
                    email: legalGuardianDetails.email.value,
                    phone: legalGuardianDetails.phone.value?.dialCode + legalGuardianDetails.phone.value?.number,
                    emergency_phone: legalGuardianDetails.emergencyPhone?.value?.dialCode + legalGuardianDetails.emergencyPhone.value?.number
                },
                address: {
                    city: addressDetails.city.value,
                    neighborhood: addressDetails.neighborhood.value,
                    street: addressDetails.street.value,
                    building: addressDetails.buildingNumber.value,
                    apartment: addressDetails.apartmentNumber.value,
                    postal_code: addressDetails.postalCode.value
                }
            }
            const response = await sixYardAxios.post('/camps/legal-info', formData);

            if (response.data.data) {
                localStorage.setItem("campRegistrationFormLegalInfo", JSON.stringify(formData))
                props.setCurrentStep(props.currentStep + 1);
                window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <form className={classes.Container} onSubmit={(e) => submitHandler(e)}>
                <div className={classes.SectionTitle}>Child's Details</div>
                <div className={classes.Field}>
                    {form(setChildDetails, childDetails)}
                </div>
                <div className={classes.SectionTitle}>Health & Medical Release Information</div>
                <div className={classes.Field}>
                    <div className={classes.RadioGroup}>
                        <div className={classes.Question}>{1}- Does the child have any allergies</div>
                        <label className={!allergies ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name={"Does the child have any allergies"}
                                value="no"
                                checked={!allergies} // Default to "No"
                                onChange={() => setAllergies(false)}
                            />No</label>
                        <label className={allergies ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name={"Does the child have any allergies"}
                                value="yes"
                                checked={allergies}
                                onChange={() => setAllergies(true)}
                            />Yes</label>
                        <div className={classes.FormGroup}>
                            <InputField
                                elementType="input"
                                elementConfig={{
                                    type: "text",
                                    placeholder: "Enter allgergies",
                                }}
                                value={allergiesDetails}
                                label="Details If Yes"
                                disabled={!allergies}
                                shouldValidate={{ required: true }}
                                changed={event => setAllergiesDetails(event.target.value)}
                            />
                        </div>
                    </div>
                    <div className={classes.RadioGroup}>
                        <div className={classes.Question}>{2}- Any medical conditions affecting sports activities</div>
                        <label className={!conditions ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name="Any medical conditions affecting sports activities"
                                value="no"
                                checked={!conditions} // Default to "No"
                                onChange={() => setConditions(false)}
                            />No</label>
                        <label className={conditions ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name="Any medical conditions affecting sports activities"
                                value="yes"
                                checked={conditions}
                                onChange={() => setConditions(true)}
                            />Yes</label>
                        <div className={classes.FormGroup}>
                            <InputField
                                elementType="input"
                                elementConfig={{
                                    type: "text",
                                    placeholder: "Enter medical conditions",
                                }}
                                value={conditionsDetails}
                                label="Details If Yes"
                                disabled={!conditions}
                                shouldValidate={{ required: true }}
                                changed={event => setConditionsDetails(event.target.value)}
                            />
                        </div>
                    </div>
                    <div className={classes.RadioGroup}>
                        <div className={classes.Question}>{3}- Does the child consume any medications</div>
                        <label className={!medications ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name="Does the child consume any medications"
                                value="no"
                                checked={!medications} // Default to "No"
                                onChange={() => setMedications(false)}
                            />No</label>
                        <label className={medications ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name="Does the child consume any medications"
                                value="yes"
                                checked={medications}
                                onChange={() => setMedications(true)}
                            />Yes</label>
                        <div className={classes.FormGroup}>
                            <InputField
                                elementType="input"
                                elementConfig={{
                                    type: "text",
                                    placeholder: "Enter medications",
                                }}
                                value={medicationsDetails}
                                label="Details If Yes"
                                disabled={!medications}
                                shouldValidate={{ required: true }}
                                changed={event => setMedicationsDetails(event.target.value)}
                            />
                        </div>
                    </div>
                    <div className={classes.RadioGroup}>
                        <div className={classes.Question}>{4}- Does the child require a special diet</div>
                        <label className={!specialDiet ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name="Does the child require a special diet"
                                value="no"
                                checked={!specialDiet} // Default to "No"
                                onChange={() => setSpecialDiet(false)}
                            />No</label>
                        <label className={specialDiet ? classes.LabelChecked : classes.UnChecked}>
                            <input
                                type="radio"
                                name="Does the child require a special diet"
                                value="yes"
                                checked={specialDiet}
                                onChange={() => setSpecialDiet(true)}
                            />Yes</label>
                        <div className={classes.FormGroup}>
                            <InputField
                                elementType="input"
                                elementConfig={{
                                    type: "text",
                                    placeholder: "Enter diet",
                                }}
                                value={specialDietDetails}
                                label="Details If Yes"
                                disabled={!specialDiet}
                                shouldValidate={{ required: true }}
                                changed={event => setSpecialDietDetails(event.target.value)}
                            />
                        </div>
                    </div>
                    {form(setHealthAndMedical, healthAndMedical)}
                </div>
                <div className={classes.SectionTitle}>Legal Guardian's Details</div>
                <div className={classes.Field}>
                    {form(setLegalGuardianDetails, legalGuardianDetails)}
                </div>
                <div className={classes.SectionTitle}>Address Details</div>
                <div className={classes.Field}>
                    {form(setAddressDetails, addressDetails)}
                </div>
                <div className={classes.Field}>
                    <p className={classes.Prompt}>
                        Please read and agree to our <a href="/privacy-policy" target='_blank' className={classes.Link}>Privacy Policy </a>
                        and <a href="/terms-and-conditions" target='_blank' className={classes.Link}>Terms</a>
                    </p>
                    <div className={classes.CheckBox}>
                        <input type="checkbox" onClick={() => setIsTermsChecked(!isTermsChecked)} />
                        <label className={classes.Label}>
                            I have read and agreed to terms and conditions  and privacy policy
                        </label>
                    </div>
                </div>
                <div className={classes.Buttons}>
                    <button onClick={backHandler}>
                        <img
                            src={DoubleArrow}
                            alt=""
                            className={classes.Icon}
                        /> BACK
                    </button>
                    <button type='submit'
                        className={[classes.Next /*, !isTermsChecked && classes.Disabled*/].join(" ")}
                    // disabled={!isTermsChecked}
                    >
                        NEXT <img
                            src={WhiteArrow}
                            alt=""
                            className={classes.Icon}
                        />
                    </button>
                </div>
            </form>
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
        </>
    )
}
export default LegalInfo;